import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";
import { motion } from "framer-motion";

const FAQS = [
  {
    q: "Where is JJ Speed Factory located?",
    a: "We're mobile. Mobile speed and athletic performance training is available throughout Northeast Ohio, including Canton, Akron, Wooster, New Philadelphia, Alliance, and surrounding communities. We train at approved parks, athletic fields, schools, and training facilities, and we'll work with you to find a safe, convenient location that fits your schedule.",
  },
  {
    q: "Do you travel for camps, clinics, or team training?",
    a: "Yes. We host elite training experiences throughout Ohio, West Virginia, Virginia, and surrounding areas. Travel opportunities, team training, and special events are available — reach out and we'll build something for your group.",
  },
  {
    q: "What does the free evaluation include?",
    a: "A full movement assessment, sprint mechanics analysis, goal setting, and personalized performance recommendations. It's the starting point for every athlete — no commitment required.",
  },
  {
    q: "How big are the small-group sessions?",
    a: "Small-group training runs with 2–6 athletes for a competitive environment with premium coaching at a shared cost. It's our most popular option.",
  },
  {
    q: "Do I need to travel to a facility?",
    a: "No — we come to you. Training happens at approved locations near you throughout Northeast Ohio (Canton, Akron, Wooster, New Philadelphia, Alliance and surrounding communities), and our Train Anywhere digital programs deliver the same JJ Speed Factory systems from anywhere.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-16 md:py-36 bg-[#0a0a0a] border-t border-white/10"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="mb-12"
        >
          <p className="font-mono-accent text-xs tracking-[0.35em] uppercase text-white/40 mb-6">
            Questions
          </p>
          <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-7xl">
            FAQ
          </h2>
        </motion.div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem key={f.q} value={`item-${i}`} className="border-white/10" data-testid={`faq-item-${i}`}>
              <AccordionTrigger className="font-display uppercase tracking-tight text-xl md:text-2xl text-left hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-white/60 text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
